import React from 'react';
import {
  Box, Button, IconButton, MenuItem, Select, Typography,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import { START_TIMES, END_TIMES, nextRange } from './weeklyHours';

// One day's time ranges: start – end selects (07:00–02:00, 30-minute steps),
// remove, and Add (proposes the 2 h after the last range). Shared by the weekly
// editor, the admin shift editor and the buyer's own shift editor.
export default function RangeList({
  ranges, onChange, idPrefix, labels = { add: 'Add', off: 'Off', remove: 'Remove range' },
}) {
  const set = (i, field, value) => onChange(ranges.map((x, j) => (j === i ? { ...x, [field]: value } : x)));
  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 1 }}>
      {ranges.map((r, i) => (
        <Box key={i} sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <Select id={`${idPrefix}-start-${i}`} size="small" value={r.start} onChange={(e) => set(i, 'start', e.target.value)}>
            {START_TIMES.map((t) => <MenuItem key={t} value={t}>{t}</MenuItem>)}
          </Select>
          –
          <Select id={`${idPrefix}-end-${i}`} size="small" value={r.end} onChange={(e) => set(i, 'end', e.target.value)}>
            {END_TIMES.map((t) => <MenuItem key={t} value={t}>{t}</MenuItem>)}
          </Select>
          <IconButton size="small" aria-label={labels.remove} onClick={() => onChange(ranges.filter((_, j) => j !== i))}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
      ))}
      {ranges.length === 0 && <Typography variant="body2" color="text.secondary">{labels.off}</Typography>}
      <Button size="small" startIcon={<AddIcon />} disabled={!nextRange(ranges)} onClick={() => onChange([...ranges, nextRange(ranges)])}>
        {labels.add}
      </Button>
    </Box>
  );
}
